module.exports = __webpack_public_path__ + "img/blood_drop_type_b_medical-512.f2187757.png";